import { render, staticRenderFns } from "./TotalSystemModal.vue?vue&type=template&id=a46a2e3c"
import script from "./TotalSystemModal.ts?vue&type=script&lang=ts&external"
export * from "./TotalSystemModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports